import {Component, Input} from "@angular/core";
import {AuthService} from "../../../../../services/auth.service";
import {RootShareService} from "../../../../../services/root.shared.service";
import {SlitLamp} from "../../../../../models/forms/referral/slit.lamp";

@Component({
    selector: 'slit-lamp-component',
    templateUrl: './slit.lamp.html'
})
export class SlitLampComponent {
    @Input() slitLamp: SlitLamp;

    @Input() patient: any;
    @Input() patientDocument: any;
    @Input() readOnly: Boolean = false;

    constructor(private _rootShareService: RootShareService, private _auth: AuthService) {
    }
}
